import React from 'react';
import AppSearchAPIConnector from '@elastic/search-ui-app-search-connector';
import { SearchProvider } from '@elastic/react-search-ui';
import '@elastic/react-search-ui-views/lib/styles/styles.css';

import {
  buildAutocompleteQueryConfig,
  buildFacetConfigFromConfig,
  buildSearchOptionsFromConfig,
  getConfig,
} from "./config/config-helper";
import Search from './containers/Search';
import { ThemeProvider } from 'theming';

const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();

const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase
});

const config = {
  searchQuery: {
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig()
  },
  autocompleteQuery: buildAutocompleteQueryConfig(),
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true
};

const theme = {
  colors: {
      active: '#0770e3', //green
      secondary: '#0E203A', //blue dark
      primary: '#444560', // blue dark
      grey: '#EFF0F3', //grey light
      secondaryHover: '#7ea530', //green
      secondaryBlue: '#05396B', //blue lighter
      secondaryGrey: 'rgba(14,32,58,0.6)', //grey with opacity
      altGrey: '#DDDDDD', //grey used on simulator
      white: '#FFFFFF',
      siteGradient: 'linear-gradient(180deg, #A2EE16 0%, #99CA3D 99.99%)',
      newBlue: '#144A82',
  },
  font: {
      poppins: 'Poppins, sans-serif',
      montserrat: 'Montserrat, sans-serif',
      proximaNova: 'Proxima Nova',
      bold: 'bold',
  },
  spacing: (size) => size * 6,
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <SearchProvider config={config}>
        <Search />
      </SearchProvider>
    </ThemeProvider>
  );
}

export default App;